const TablePreferencesConstants = {
  // Column specific
  SET_SELECTED_COLUMNS: 'SR_TABLEPREFS_SET_SELECTED_COLUMNS',
  SET_COLUMN_WIDTHS: 'SR_TABLEPREFS_SET_COLUMN_WIDTHS',
  SET_COLUMN_ORDER: 'SR_TABLEPREFS_SET_COLUMN_ORDER',
  SET_TABLE_SORTORDER: 'SR_TABLEPREFS_SET_TABLE_SORTORDER',
  GET_SUCCESS: 'SR_TABLEPREFS_GET_SUCCESS',

  // NOT USED, Defined for safety: prevent case matching for 'undefined'.
  RESET: 'NOT_USED_TABLEPREFS_RESET',
  GET: 'NOT_USED_TABLEPREFS_GET',
  GET_FAIL: 'NOT_USED_TABLEPREFS_GET_FAIL',
  GET_FOR_OPEN: 'NOT_USED_TABLEPREFS_GET_FOR_OPEN',
  GET_FOR_OPEN_SUCCESS: 'NOT_USED_TABLEPREFS_GET_FOR_OPEN_SUCCESS',
  GET_FOR_OPEN_FAIL: 'NOT_USED_TABLEPREFS_GET_FOR_OPEN_FAIL',
  SAVE: 'NOT_USED_TABLEPREFS_SAVE',
  SAVE_SUCCESS: 'NOT_USED_TABLEPREFS_SAVE_SUCCESS',
  SAVE_FAIL: 'NOT_USED_TABLEPREFS_SAVE_FAIL',
  REMOVE: 'NOT_USED_TABLEPREFS_REMOVE',
  REMOVE_SUCCESS: 'NOT_USED_TABLEPREFS_REMOVE_SUCCESS',
  REMOVE_FAIL: 'NOT_USED_TABLEPREFS_REMOVE_FAIL',
  CREATE: 'NOT_USED_TABLEPREFS_CREATE',
  OPEN: 'NOT_USED_TABLEPREFS_OPEN',
  OPEN_READONLY: 'NOT_USED_TABLEPREFS_OPEN_READONLY',
  MODIFY: 'NOT_USED_TABLEPREFS_MODIFY',
  RELOAD: 'NOT_USED_TABLEPREFS_RELOAD',
  SET_VISIBLE_RANGE: 'NOT_USED_TABLEPREFS_SET_VISIBLE_RANGE',
  SET_FILTER: 'NOT_USED_TABLEPREFS_SET_FILTER',
  SET_SORTORDER: 'NOT_USED_TABLEPREFS_SET_SORTORDER',
  SET_SELECTION: 'NOT_USED_TABLEPREFS_SET_SELECTION',
  MODIFY_SELECTION: 'NOT_USED_TABLEPREFS_MODIFY_SELECTION',
  ALLOW_MULTI_SELECT: 'NOT_USED_TABLEPREFS_ALLOW_MULTI_SELECT',
  ENSURE_SELECTION_IS_VISIBLE: 'NOT_USED_TABLEPREFS_ENSURE_SELECTION_IS_VISIBLE',
  FIND: 'NOT_USED_TABLEPREFS_FIND',
  FIND_SUCCESS: 'NOT_USED_TABLEPREFS_FIND_SUCCESS',
  FIND_FAIL: 'NOT_USED_TABLEPREFS_FIND_FAIL'
};

export default TablePreferencesConstants;